export enum RelationRequestTables {
  CONNECTION_LIST,
  CONNECTION_REQUESTS,
  CONNECTIONS_SENT_REQUESTS,
  CONNECTIONS_RECEIVED_INVITES,
  DOCTOR_LINKED_REQUESTS,
  DOCTOR_SENT_LINK_REQUEST,
  DOCTOR_RECEIVED_LINK_REQUEST,
  PATIENT_LINKED_REQUESTS,
  PATIENT_RECEIVED_LINK_REQUEST,
  PATIENT_SENT_LINK_REQUEST,
}
